import { dateToDateOnlyApiFormat, getDatesInRange } from '@/helpers/dateHelper';
import { handleMutationResult } from '@/helpers/toastHelper';
import { useConfirm } from '@/services/confirm/ConfirmationService';
import {
  UpdateAvailabilityExceptionDetail,
  useUpdateAvailabilityExceptionsMutation
} from '@/services/gql/graphql.generated';
import { useCallback, useState } from 'react';

export const useRequestLeave = () => {
  const [, updateExceptions] = useUpdateAvailabilityExceptionsMutation();
  const [fetching, setFetching] = useState(false);

  const { unregisterConfirmation } = useConfirm(state => ({
    unregisterConfirmation: state.unregisterForConfirmation
  }));

  const requestLeave = useCallback(
    async (start: Date, end: Date, leaveTypeId: string) => {
      const exceptions: UpdateAvailabilityExceptionDetail[] = getDatesInRange(start, end).map(date => ({
        date: dateToDateOnlyApiFormat(date),
        leaveTypeId
      }));

      setFetching(true);

      try {
        const result = await updateExceptions({
          exceptions: {
            employeeExceptions: [
              {
                exceptions
              }
            ],
            start: dateToDateOnlyApiFormat(start),
            end: dateToDateOnlyApiFormat(end)
          }
        });

        return await handleMutationResult(result, {
          successMessage: 'Leave requested successfully.',
          onSuccess: unregisterConfirmation
        });
      } finally {
        setFetching(false);
      }
    },
    [updateExceptions, unregisterConfirmation]
  );

  return { requestLeave, fetching };
};
